import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

import { cn } from '~/lib/cn';
import { FlexCol } from '~/modules/artist-roster/components/flex/FlexCol';
import { MusicIqIcon } from '~/modules/music-iq/pages/chatbot-page/components/MusicIqIcon';

import type { ChatMessage } from '../types';

interface MessageProps {
  message: ChatMessage;
}

export function Message({ message }: MessageProps) {
  // User messages go on the right side of the thread. If a user aborted a
  // question, that displays on the left side of the thread.
  const isUserMessage = message.type === 'user' && !message.wasAborted;

  if (!message.content) {
    return null;
  }

  return (
    <div
      className={cn(
        'flex w-full text-body-sm leading-5',
        isUserMessage ? 'justify-end' : 'justify-start',
      )}
    >
      {isUserMessage ? (
        <div className="max-w-[80%] rounded-sm p-md bg-primary-default">
          <p className="whitespace-pre-wrap text-body-sm">{message.content}</p>
        </div>
      ) : (
        <FlexCol className="w-full">
          <MusicIqIcon className="mb-sm mt-md h-[22px] w-[22px]" />
          <div className={cn('max-w-[80%] overflow-y-auto')}>
            {message.wasAborted ? (
              <span className="italic">{message.content}</span>
            ) : (
              <div className="prose prose-sm prose-invert max-w-none">
                <Markdown remarkPlugins={[remarkGfm]}>
                  {message.content}
                </Markdown>
              </div>
            )}
          </div>
        </FlexCol>
      )}
    </div>
  );
}

Message.displayName = 'Message';
